import {
  Actions,
  ExtendedWindow,
} from '../../core/interfaces/window.interface';

declare let window: ExtendedWindow;
// eslint-disable-next-line
declare let Android: Actions;

export function isNativeClient() {
  const isAndroid = window.Android !== undefined && window.Android !== null;
  const isiOS = window.iOS !== undefined && window.iOS !== null;

  return isAndroid || isiOS;
}

export function processAppConfigByNativeClientStatus(
  appConfig: Record<string, any>,
  isNativeClient: boolean,
) {
  if (!appConfig) return appConfig;
  const processValue = (value) =>
    value instanceof Object
      ? processAppConfigByNativeClientStatus(value, isNativeClient)
      : value;

  const NATIVE_CLIENT_KEY_PREFIX = 'native::';
  const isKeyForNativeClient = (key: string) =>
    key.startsWith(NATIVE_CLIENT_KEY_PREFIX);
  const getKeyNameWithoutPrefix = (key: string) =>
    isKeyForNativeClient(key)
      ? key.slice(NATIVE_CLIENT_KEY_PREFIX.length)
      : key;

  const keys = Object.keys(appConfig);
  const keysForNativeClient = keys.filter(isKeyForNativeClient);
  const keysForNativeClientWithoutPrefix = keysForNativeClient.map(
    getKeyNameWithoutPrefix,
  );

  const isKeyHasNativeClientValue = (key: string) =>
    keysForNativeClientWithoutPrefix.includes(getKeyNameWithoutPrefix(key));

  const isKeyToUse = (key: string) =>
    isNativeClient
      ? isKeyForNativeClient(key) || !isKeyHasNativeClientValue(key)
      : !isKeyForNativeClient(key);

  return keys.filter(isKeyToUse).reduce(
    (acc, key) => ({
      ...acc,
      [getKeyNameWithoutPrefix(key)]: processValue(appConfig[key]),
    }),
    {},
  );
}
